import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-asbsbthome',
    templateUrl: './asbsbthome.component.html',
    styleUrls: ['./asbsbthome.component.scss']
})
export class AsbsbthomeComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Master of Science Courses at ARNI School of Sciences');
        this.meta.updateTag({
            name: 'description',
            content: `Explore master of science courses at ARNI School of Basic Sciences & Biotechnology. Advance your knowledge and skills in science and biotechnology for a bright future.`
        });
    }

}
